module.exports = __webpack_public_path__ + "static/media/it.606c6ac8.png";